import "./app.css";
import initResultsSwiper from "./js/resultsSlider";
import initSwellSwiperReset from "./js/pickupSlider";
import initScrollShowElement from "./js/common";
import initColumnSwiper from "./js/columnSlider";
import disablePowconLinks from "./js/productList";
import hackSwellPickupSlider from "./js/swell-swiper-hack";
import { initEmailValidator, initFormRedirect, initFilePreview, initFileValidator, initPrivacyValidator } from "./js/form";
import initDataTextHelper from "./js/dataText";
import { initFaqAccordion } from "./js/faqAccordion";
import { handleEmptyShopColumns } from "./js/company";
import { hideEmptyPriceContentItems } from "./js/priceContent";

// ① 初回ページ読み込み時（DOMが完成した瞬間）に実行
document.addEventListener("DOMContentLoaded", () => {
	initResultsSwiper();
	initSwellSwiperReset();
	initScrollShowElement();
	initColumnSwiper();
	hackSwellPickupSlider();
	initEmailValidator();
	initFormRedirect();
	initFilePreview();
	initFileValidator();
	disablePowconLinks();
	initDataTextHelper();
	initPrivacyValidator();
	initFaqAccordion();
	handleEmptyShopColumns();
	hideEmptyPriceContentItems();
});

// ② SWELLのPJAX（非同期）遷移完了時にも実行
window.addEventListener("swell_pjax_sc_loaded", () => {
	initResultsSwiper();
	initSwellSwiperReset();
	initScrollShowElement();
	initColumnSwiper();
	hackSwellPickupSlider();
	initEmailValidator();
	initFormRedirect();
	initFilePreview();
	initFileValidator();
	disablePowconLinks();
	initDataTextHelper();
	initPrivacyValidator();
	initFaqAccordion();
	handleEmptyShopColumns();
	hideEmptyPriceContentItems();
});
